import { render, staticRenderFns } from "./Diary2.vue?vue&type=template&id=4fbb07f0&scoped=true"
import script from "./Diary2.vue?vue&type=script&lang=js"
export * from "./Diary2.vue?vue&type=script&lang=js"
import style0 from "./Diary2.vue?vue&type=style&index=0&id=4fbb07f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbb07f0",
  null
  
)

export default component.exports